import { Box } from 'grid-styled'
import * as React from 'react'
import Layout from '../../components/Layout'
import { graphql, Link } from 'gatsby'
import Img from 'gatsby-image'

import Target from 'react-icons/lib/fa/bullseye'
import Award from 'react-icons/lib/fa/shield'
import Atlas from 'react-icons/lib/fa/skyatlas'
import Card from '../../components/Card'
import CTA from '../../components/CTA'

import {
  Cards,
  Container,
  Hero,
  HeroContent,
  HeroFigure,
  HeroMain,
  SplitSection,
  SplitFigure,
  SplitContent,
  Text,
  ReadMore
} from '../../components/styles'
import { Button } from '../../components/Button'
import FAQs from '../../components/FAQs'
import Form from '../../components/Form'
import { WebCases } from '../../components/case-studies/WebCases'
import Arrow from '../../components/Arrow'
import Testimonials from '../../components/Testimonials'
import { testimonials } from '../testimonials'
import { Helmet } from 'react-helmet'

export const faqsInfo = [
  {
    title: 'Common web design questions'
  },
  {
    answer: `How about more traffic, more conversions, more sales, more profit, more freedom? Is that a good reason. But seriously, just look around at the statistics on your websites impact on your business. It really is make or break.`,
    question: 'What are the benefits of a great website?'
  },
  {
    answer: `Every business and website is unique. Generally, most websites will be completed in less than 3 weeks. This includes the time to design, review and review.`,
    question: `How long does it take to develop a website?`
  },
  {
    answer: `Of course. Every single website we do is completely custom and unique, our designers will work with your brand, logos and core vision to develop a website that completely fits with your business.`,
    question: `Will the website fit with my brand?`
  },
  {
    answer: `Our designers are pretty good. In fact we're so confident that we leave you the right to make any changes or modifications or recommendations on everything we do. We're sure you'll love it, but we understand you have your own vision and requirements that you understand better than anyone.`,
    question: `What if I'm not happy with the designs?`
  },
  {
    answer: `Since all our websites are custom, we don't have a single one size fits all pricing model. We can cater for a wide variety of price ranges, it all comes down to your specific needs. Contact us today to discuss what's best for you.`,
    question: `How much does it cost?`
  },
  {
    answer: `Our programmers have a history of security and hacking prevention, everything we do will be up to the latest standards in online security to ensure your customers personal data is safe and you don't have to deal with malicious competitors.`,
    question: `Will it be secure?`
  }
]

/* prettier-ignore */
interface IProps {
  data: {
    adjustments: {
      childImageSharp: {
        fluid: object
      }
    };
    research: {
      childImageSharp: {
        fluid: object
      }
    };
    flows: {
      childImageSharp: {
        fluid: object
      }
    };
    inf: {
      childImageSharp: {
        fluid: object
      }
    };
    programmer: {
      childImageSharp: {
        fluid: object
      }
    };
    hero: {
      childImageSharp: {
        fluid: object
      }
    };
  }
}

export default ({ data }: IProps) => (
  <Layout>
    <Helmet>
      <title>
        Website Development Brisbane - Beautiful Responsive Websites -
        Turboclicks
      </title>
      <meta
        name="description"
        content="We help businesses tangibly grow their business sales through effective and modern SEO practices. Don't miss out on the world's largest marketplace."
      />
    </Helmet>
    <Hero>
      <Container>
        <HeroContent>
          <HeroMain>
            <h1>Website development</h1>
            <p>
              Too many websites are hard to navigate, sluggish, and full of
              vulnerabilities. We've got a team of experieced designers,
              programmers and writers to build the best possible site.
              Everything we do is deliberate. To put it simply, we don't build
              crap.
            </p>
            {/* <Announcement to="/">
              Speak with a specialist
              <Arrow rotate="-90deg" />
            </Announcement> */}
            <Link to="/contact#form">
              <Button inverted={true}>Modernise my web presence</Button>
            </Link>
          </HeroMain>

          <HeroFigure>
            <Img
              fluid={data.hero.childImageSharp.fluid}
              alt="Turboclicks website development in Brisbane"
            />
          </HeroFigure>
        </HeroContent>
      </Container>
    </Hero>

    <CTA
      inverted={true}
      to="/free-audit/"
      title="Want your website reviewed?"
      subtitle="100% free, no obligations"
      button="Request my free website audit"
    />

    <WebCases image={data.inf.childImageSharp.fluid} />

    <Container padY={true}>
      <Cards>
        <Card
          color="primary"
          title="In house specialists"
          content="We know just how important your website is. Our team is trained in programming, graphic design, and copywriting to ensure each aspect is done professionally and effectively to achieve your business goals."
        >
          <Target />
        </Card>

        <Card
          color="tertiary"
          title="Proven &amp; experienced"
          content="With years of industry experience in the field. Having worked with large multinationals, local sports clubs, and online startups alike we know exactly how to build the perfect website for you unique business needs."
        >
          <Award />
        </Card>

        <Card
          color="purple"
          title="Deliberate"
          content="Everything we do is with purpose. We have a big picture view of your website. Addressing everything from security, and speed to design and ability to convert. We have a unique process stemming from combining different perspectives."
        >
          <Atlas />
        </Card>
      </Cards>
    </Container>

    <Box mt={4}>
      <Container
        image="https://images.weserv.nl/?url=//mbrit.worldsecuresystems.com/images/business-directory/Brisbane_Whale_Watching/Brisbane_Whale_Watching_Close_Humpback_Whale_Encounters_Moreton_Bay.jpg&bri=-25&blur=20"
        full={true}
        padY={true}
      >
        <Container medium={true}>
          <h2>
            We've worked with some of the most trusted brands in Brisbane. And
            we'd like to work with you too.
          </h2>
        </Container>
      </Container>
    </Box>

    <Container padY={true} medium={true}>
      <SplitSection>
        <SplitFigure>
          <Img
            fluid={data.research.childImageSharp.fluid}
            alt="Statistics and website development audit"
          />
        </SplitFigure>
        <SplitContent>
          <h2>1. Research and review</h2>
          <ul>
            <li>Come up with an online brand strategy</li>
            <li>Audit your historical web performance</li>
            <li>
              Understand your user demographics, create user personas and
              stories to guide our actions
            </li>
            <li>Review competitor sites and strategies</li>
            <li>Set up clear project milestones and goals</li>
          </ul>
          <ReadMore to="/contact">
            Have us conduct a full review <Arrow rotate="-90deg" />
          </ReadMore>
        </SplitContent>
      </SplitSection>

      <SplitSection alternate={true} padY={true}>
        <SplitFigure>
          <Img
            fluid={data.flows.childImageSharp.fluid}
            alt="Wireframes and user flows for website"
          />
        </SplitFigure>
        <SplitContent>
          <h2>2. Flows and page designs</h2>
          <ul>
            <li>
              Based on all our research and audits we start the process of
              designing your website's layout
            </li>
            <li>
              Once we've got the perfect structure and layout we create
              wireframes to map out placement of critical content
            </li>
            <li>
              Next, we add the polish. Creating pages suited to your unique
              brand style and expression
            </li>
            <li>
              All our designs are oriented to effectively address the concerns
              of your target audience
            </li>
          </ul>
          <ReadMore to="/contact">
            Don't miss out on thousands in sales <Arrow rotate="-90deg" />
          </ReadMore>
        </SplitContent>
      </SplitSection>

      <SplitSection>
        <SplitFigure>
          <Img
            fluid={data.adjustments.childImageSharp.fluid}
            alt="Client reviewing website designs"
          />
        </SplitFigure>
        <SplitContent>
          <h2>3. Feedback &amp; adjustment</h2>
          <ul>
            <li>
              We don't operate in a vaccuum. Once we've done the boring stuff,
              we come to you with our first set of designs
            </li>
            <li>
              You're free to review, critique, and modify the designs to your
              liking; it is after all, your business
            </li>
            <li>
              We will provide guidance, statistics and explain our reasoning for
              each and every aspect of our design for you to come to the most
              informed decision
            </li>
            <li>
              After your review, it's back to work implementing the changes and
              repeat
            </li>
          </ul>
          <ReadMore to="/contact">
            Let's create something great together
            <Arrow rotate="-90deg" />
          </ReadMore>
        </SplitContent>
      </SplitSection>

      <SplitSection alternate={true} padY={true}>
        <SplitFigure>
          <Img
            fluid={data.programmer.childImageSharp.fluid}
            alt="Turboclicks programmer working on website development"
          />
        </SplitFigure>
        <SplitContent>
          <h2>4. We toil away</h2>
          <ul>
            <li>
              With the designs done and the review complete, we're ready to
              start developing
            </li>
            <li>
              This is where our programmers shine, they'll translate your
              designs into the world of code and produce a responsive, dynamic
              site
            </li>
            <li>
              In tandem with our writers we'll work together to produce the best
              content targetted at your users to clearly and directly explain
              who you are and what you offer
            </li>
            <li>
              After a final round of checks, integrations and optimisation we're
              ready to go live and introduce the world to you brand new site
            </li>
          </ul>

          <ReadMore to="/contact">
            Create your sales powerhouse <Arrow rotate="-90deg" />
          </ReadMore>
        </SplitContent>
      </SplitSection>
    </Container>

    <CTA
      inverted={true}
      title="Want to know how we can help?"
      subtitle="We’d love to chat"
      button="Speak to a specialist"
    />

    <Container padY={true} medium={true}>
      <h3>The benefits of a great website</h3>

      <h5>Don't be foolish</h5>
      <Text size="large">
        If you don't have a website you're effectively missing out on the single
        biggest source of traffic in the modern world. But, if you've got a
        crappy website, you could be destroying your reputation, being punished
        by google and losing tens of thousands of dollars in profit.
      </Text>

      <h5>Speed is everything</h5>
      <Text size="large">
        Did you know that 47% of online users expect a page to load in less than
        2 seconds. That a 1 second decrease in page load time will improve your
        SEO and increase your page views by 11%. And that every 1 second of page
        load time decreases conversions by 7%.
      </Text>
      <Text size="large">
        These statistics shouldn't make you feel worried. With the right
        website, they can all be used to your advantage. Increase conversions,
        improve bounce rate, increase page views, and get more sales from
        happier customers.
      </Text>

      <h5>Get more leads</h5>
      <Text size="large">
        Our web development team is completely in-house, right here in Brisbane.
        We value ongoing communication so we can develop the best website for
        your business.
      </Text>
      <Text size="large">
        With our ability to regularly communicate, matched with our
        understanding of the local market (hey, we're locals too) we can truly
        develop a website that is going to act as a funnel for your leads.
        Something that can produce new traffic, and more importantly high
        quality sales.
      </Text>

      <h5>Be proud of your brand</h5>
      <Text size="large">
        Many web agencies use pre-designed stock templates to throw together
        their clients websites. The result is a website that looks bland, is
        often 3 to 5 years out of date and is difficult to customise and expand
        in the future. Turboclicks works with you to build completely custom and
        designed to fit your unique needs.
      </Text>
      <Text size="large">
        We have developers who have years of industry experience in builidng
        marketing sites and large, complex web applications (think Facebook, or
        AirBnB) and who are up to date with the ever-changing ecosystem but
        still retain timeless best practices.
      </Text>
    </Container>

    <FAQs data={faqsInfo} flushTop={true} />

    <Testimonials testimonials={testimonials} />

    <Form />
  </Layout>
)

export const query = graphql`
  query WebDevelopmentPageQuery {
    hero: file(relativePath: { eq: "woman-website.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    programmer: file(
      relativePath: { eq: "website-development-programmer.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    flows: file(relativePath: { eq: "turboclicks-user-flows.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    research: file(relativePath: { eq: "turboclicks-website-conversion.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    inf: file(
      relativePath: { eq: "turboclicks-theinflatablefactory-case.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    adjustments: file(relativePath: { eq: "man-programming.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
